import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga4';

ReactGA.initialize('G-CKSFY9Q6K1');

TagManager.initialize({
  gtmId: 'GTM-5PP2Z7SF',
});

createRoot(document.getElementById('root')).render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
